import React from 'react';
import { Route } from 'react-router';
import { Switch } from 'react-router-dom';

import Auth from './auth';
import Home from './containers/home';
import Login from './containers/login';
import Password from './containers/password';
import Profile from './containers/profile';
import DefaultLayout from './layouts/default';

const MainComponets = () => (
  <DefaultLayout>
    <Switch>
      <Route exact path="/" component={Login} />
      <Route exact path="/login" component={Login} />
      <Auth>
        <Switch>
          <Route exact path="/password" component={Password} />
          <Route exact path="/profile" component={Profile} />
          <Route exact path="/home" component={Home} />
        </Switch>
      </Auth>
    </Switch>
  </DefaultLayout>
);

const Routes = (
  <Switch>
    <Route component={MainComponets} />
  </Switch>
);

export default Routes;
